import React from "react";
import Create from "modules/assignmentRules/components/Create";

const AssignmentRulesCreatePage = () => {
  return <Create />;
};

export default AssignmentRulesCreatePage;
